import { useState, useEffect } from 'react';
import { reviewsService } from '@/services/reviews';

interface Review {
  id: string;
  name: string;
  email: string | null;
  rating: number;
  review_text: string;
  created_at: string | null;
}

export function useReviews() {
  const [reviews, setReviews] = useState<Review[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    async function loadReviews() {
      try {
        const { data, error } = await reviewsService.getApprovedReviews();
        if (error) throw error;
        if (data) setReviews(data);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to load reviews'));
      } finally {
        setIsLoading(false);
      }
    }

    loadReviews();
  }, []);

  return { reviews, isLoading, error };
} 